import { SVGProps, Ref, forwardRef } from 'react';

export const ShareIosOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M4.172 4.328 8 .5l3.828 3.828-.99.99L8.7 3.18v6.977H7.3V3.18L5.16 5.318z"
                    fill="currentColor"
                />
                <path
                    d="M8 15.5C1.438 15.5.5 14.563.5 8h1.4c0 1.63.06 2.808.225 3.681.162.86.4 1.287.654 1.54.253.253.68.492 1.54.654.873.165 2.051.225 3.681.225s2.808-.06 3.681-.225c.86-.162 1.287-.4 1.54-.654.253-.253.492-.68.654-1.54.165-.873.225-2.051.225-3.681h1.4c0 6.563-.937 7.5-7.5 7.5"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ShareIosOutlinedSize16Glyph.displayName = 'ShareIosOutlinedSize16Glyph';
